import React, {useContext} from 'react';
import { Formik, Form } from 'formik';
import useFormSubmit from '~/hooks/useFormSubmit';
import * as Yup from 'yup';

import InputField from '~/components/Forms/Fields/InputField';
import SelectField from '~/components/Forms/Fields/SelectField';
import CheckboxField from '~/components/Forms/Fields/CheckboxField';
import MultiOptionSelectField from '~/components/Forms/Fields/MultiOptionSelectField';
import TransContext from '~/contexts/TransContext';

import countries from '~/data/countries';

const validationSchema = Yup.object({
  contact: Yup.object({
    FirstName: Yup.string().required('Required'),
    LastName: Yup.string().required('Required'),
    Email: Yup.string().email('Invalid email address').required('Required'),
    Phone: Yup.string().required('Required'),
    Company: Yup.string().required('Required'),
    NumberOfEmployees: Yup.string().required('Required'),
    Country: Yup.string().required('Required'),
    AcceptTerms: Yup.boolean().oneOf([true], 'This field must be checked'),
    custom: Yup.object({
      'string--OrdersPerMonth': Yup.string().required('Required'),
    })
  })
});

export default function GetStartedForm({ setIsSubmitted }) {
  const trans = useContext(TransContext);

  const { post, loading, response } = useFormSubmit({
    url: '/.netlify/functions/autopilot-form',
    setIsSubmitted
  });

  return (
    <Formik
      initialValues={{
        contact: {
          FirstName: '',
          LastName: '',
          Email: '',
          Phone: '',
          Company: '',
          NumberOfEmployees: '',
          Country: '',
          AcceptTerms: false,
          Newsletter: false,
          custom: {
            'string--OrdersPerMonth': '',
          }
        }
      }}
      validationSchema={validationSchema}
      onSubmit={async (values) => {
        await post(values);
      }}
    >
      {(props) => (
        <Form className="mt-12">
          {/* <pre>{JSON.stringify(props, null, 4)}</pre> */}
          <div className="grid md:grid-cols-2 gap-8">
            <InputField name="contact.FirstName" type="text" placeholder={trans?.content?.firstNamePlaceholder} label={trans?.content?.firstNameLabel} />
            <InputField name="contact.LastName" type="text" placeholder={trans?.content?.lastNamePlaceholder} label={trans?.content?.lastNameLabel} />
            <InputField name="contact.Email" type="email" placeholder={trans?.content?.emailPlaceholder} label={trans?.content?.emailLabel} />
            <InputField name="contact.Phone" type="text" placeholder={trans?.content?.phonePlaceholder} label={trans?.content?.phoneLabel} />
            <InputField name="contact.Company" type="text" placeholder={trans?.content?.companyPlaceholder} label={trans?.content?.companyLabel} />
            <MultiOptionSelectField
              name="contact.NumberOfEmployees"
              label={trans?.content?.numberEmployeesLabel}
              options={[
                {
                  label: '<50',
                  value: '0-50',
                },
                {
                  label: '50-999',
                  value: '50-999',
                },
                {
                  label: '1000+',
                  value: '1000+',
                },
              ]}
            />
            <SelectField name="contact.Country" label={trans?.content?.countryLabel} options={[trans.content.countryPlaceholder, ...countries]} />
            <SelectField name="contact.custom.string--OrdersPerMonth" label={trans?.content?.ordersPerMonthLabel} options={[trans?.content?.ordersPerMonthPlaceholder, '0-10', '11-50', '51-100', '100+']} />
          </div>


          <div className="mt-10">
            <CheckboxField
              name="contact.AcceptTerms"
              label={trans?.content?.termsLabel}
            />
            <CheckboxField
              name="contact.Newsletter"
              label={trans?.content?.newsletterLabel}
            />
          </div>

          <div className="mt-8">
            <button
              type="submit"
              className="w-full flex flex-col justify-center bg-blue hover:opacity-80 transition-opacity duration-100"
            >
              <div className="pointer-events-none c-btn c-btn--primary hover:bg-blue mx-auto">Request a demo</div>
            </button>
          </div>
        </Form>
      )}
    </Formik>
  );
}
